var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUploadMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "49px",
    height: "34px",
    viewBox: "0 0 49 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Platform-Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Platform-Admin-/-Courses-/-Create-New-Course-preview-upload-magnifing-glass",
    transform: "translate(-334.000000, -967.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Upload/File/Regular",
    transform: "translate(126.000000, 898.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(130.000000, 62.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Cloud-upload",
    transform: "translate(78.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.32,21.76875 C40.6275,20.9566964 40.8,20.06875 40.8,19.1428571 C40.8,15.1205357 37.575,11.8571429 33.6,11.8571429 C32.1225,11.8571429 30.7425,12.3125 29.6025,13.0866071 C27.525,9.44375 23.6475,7 19.2,7 C12.57,7 7.2,12.4339286 7.2,19.1428571 C7.2,19.3477679 7.2075,19.5526786 7.215,19.7575893 C3.015,21.2526786 0,25.3053571 0,30.0714286 C0,36.1049107 4.8375,41 10.8,41 L38.4,41 C43.7025,41 48,36.6513393 48,31.2857143 C48,26.5879464 44.7,22.6642857 40.32,21.76875 Z M29.8275,26.603125 L29.0175,27.4227679 C28.2975,28.1513393 27.1275,28.1285714 26.43,27.3848214 L24,24.7665179 L24,34.3214286 C24,35.3308036 23.1975,36.1428571 22.2,36.1428571 L21,36.1428571 C20.0025,36.1428571 19.2,35.3308036 19.2,34.3214286 L19.2,24.7665179 L16.77,27.3848214 C16.0725,28.1361607 14.9025,28.1513393 14.1825,27.4227679 L13.3725,26.603125 C12.6675,25.8897321 12.6675,24.7361607 13.3725,24.0303571 L20.325,16.9950893 C21.03,16.2816964 22.17,16.2816964 22.8675,16.9950893 L29.82,24.0303571 C30.525,24.74375 30.525,25.8973214 29.8275,26.603125 L29.8275,26.603125 Z",
    id: "Icon",
    fill: "#898F9E"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadMedia);
export default __webpack_public_path__ + "static/media/icon-upload-media.f79c3cb2.svg";
export { ForwardRef as ReactComponent };